module.exports = __webpack_public_path__ + "img/6.96f5810f.jpg";